'use strict';

function LicenceInfo() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_AccountController];
  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
    this.analytics.pushEvent('virtual-page-view');

    var promoCode = new PromoCode();
    if (promoCode.exists(this.presenter.models.account) || this._directToLoansDashboard()) {
      $('.js--viewed-licence').attr('href', this.paths.loans.preapproval);
    }
  };

  this._directToLoansDashboard = function () {
    var arrayOfInterest = this.presenter.models.account.products_of_interest;
    var productOfInterest = 'loan';
    // A new user who selects Loans Only as a Product interest and received a Money Pre-approval
    if (this._onlyInterest(arrayOfInterest, productOfInterest) && arrayOfInterest.length === 1) {
      return true;
    }
  };

  // Returns True if name is found in the array.
  this._onlyInterest = function (arrayObj, name) {
    return arrayObj.some(function (arrayElement) {
      return arrayElement.product === name;
    });
  };
}